export const BillTableStatusColorMap = {
  10: "success",
  99: "danger",
  90: "warning",
  1: "warning",
};